import React from 'react'
import SideNav from '../../layouts/side-nav.js'
import caseStudy from './data/case-study.json'

import './style/case-study.css'

const components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business']

export default (props) => (
  <div>
    <div className='case-hero'>
      <div className='case-hero-img' />
    </div>
    <div className='case-title'>
      Case Study
    </div>
    <div className='case-content'>
      <SideNav components={components} base='why' current='case-study' />
      <div className='case-study-section-title'>Company Background:</div>
      <p className='case-study-section'>{caseStudy.background}</p>
      <div className='case-study-section-title'>What was the Need?</div>
      <p className='case-study-section'>
        {caseStudy.needs.map((paragraph, i) => (<p key={i} className='needs-paragraph'>{paragraph}</p>))}
      </p>
      <div className='case-study-section-title'>What were the Terms of the Lease:</div>
      <p className='case-study-section'>{caseStudy.terms}</p>
      <div className='case-study-section-title'>Results:</div>
      <p className='case-study-section'>{caseStudy.results}</p>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/why/case-study.js